import { render } from "./OptionsManage.vue?vue&type=template&id=6db1c09c&scoped=true&ts=true"
import script from "./OptionsManage.vue?vue&type=script&lang=ts"
export * from "./OptionsManage.vue?vue&type=script&lang=ts"

import "./OptionsManage.vue?vue&type=style&index=0&id=6db1c09c&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db1c09c"]])

export default __exports__